// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.11.7
//   protoc               v5.29.6
// source: pms.proto

export const protobufPackage = 'compasspb';

/** Result-set state for a candidate search. Numeric on the wire. */
export enum PmsResultState {
  PMS_RESULT_STATE_UNSPECIFIED = 0,
  /** PMS_RESULT_STATE_NONE - no candidates after the server retry ladder */
  PMS_RESULT_STATE_NONE = 1,
  /** PMS_RESULT_STATE_SINGLE - exactly one candidate */
  PMS_RESULT_STATE_SINGLE = 2,
  /** PMS_RESULT_STATE_MULTIPLE - 2..page-size candidates */
  PMS_RESULT_STATE_MULTIPLE = 3,
  /** PMS_RESULT_STATE_CAPPED - more matches than the page; narrow or page */
  PMS_RESULT_STATE_CAPPED = 4,
  /** PMS_RESULT_STATE_ERROR - adapter unavailable — degraded mode */
  PMS_RESULT_STATE_ERROR = 5,
}

/**
 * Per-field fill policy (R8). Assigned in the epostrx-go mapping
 * (mappings/pms-schema.yaml), never derived client-side. AUTOFILL commits
 * only when exactly one value exists.
 */
export enum PmsFillPolicy {
  PMS_FILL_POLICY_UNSPECIFIED = 0,
  PMS_FILL_POLICY_AUTOFILL = 1,
  PMS_FILL_POLICY_OFFER = 2,
}

/** Why a mapped field has no PMS value. */
export enum PmsGapReason {
  PMS_GAP_REASON_UNSPECIFIED = 0,
  /** PMS_GAP_REASON_ASK - no system holds it — ask the reporter */
  PMS_GAP_REASON_ASK = 1,
  /** PMS_GAP_REASON_NOT_IN_PMS - PMS/adapter does not carry it */
  PMS_GAP_REASON_NOT_IN_PMS = 2,
}

export interface SearchPmsPatientsRequest {
  organization_id?: string | undefined;
  program_id?: string | undefined;
  /**
   * Program context: Compass resolves the pms_enabled gate, the schema
   * module (keys the epostrx-go mapping), and the workflow name (drives the
   * in_program manufacturer match) from this workflow id in its own DB —
   * never from client-supplied values.
   */
  workflow_id?: string | undefined;
  /** required (>=2 chars) unless patient_id is set */
  last_name?: string | undefined;
  /** optional */
  first_name?: string | undefined;
  /** optional, ISO 8601 (YYYY-MM-DD) */
  dob?: string | undefined;
  /** PMS mfi — direct-lookup mode */
  patient_id?: string | undefined;
  /** adapter page cap is 10 */
  page_size?: number | undefined;
  /** adapter cursor for "show more"; empty = first page */
  page_token?: string | undefined;
}

export interface SearchPmsPatientsResponse {
  /** Ranked by adapter match score, never alphabetical. */
  candidates?: PmsCandidate[] | undefined;
  result_state?: PmsResultState | undefined;
  /** Full match-set count from the adapter (not the page size). */
  total_matches?: number | undefined;
  /** Empty when the result set is exhausted. */
  next_page_token?: string | undefined;
}

export interface PmsCandidate {
  mfi?: string | undefined;
  epost_member_id?: string | undefined;
  /** PMS spelling — UI tags "close match" when fuzzy */
  first_name?: string | undefined;
  last_name?: string | undefined;
  /** ISO 8601 — the primary verification attribute */
  dob?: string | undefined;
  zip?: string | undefined;
  /** data minimization: cards carry last-4 only */
  phone_last4?: string | undefined;
  fuzzy_matched?: boolean | undefined;
}

export interface GetPmsPatientPrefillRequest {
  organization_id?: string | undefined;
  program_id?: string | undefined;
  workflow_id?: string | undefined;
  /** path parameter */
  mfi?: string | undefined;
  /** optional; improves patient-scoped adapter calls */
  epost_member_id?: string | undefined;
}

export interface GetPmsPatientPrefillResponse {
  patient?: PmsPatient | undefined;
  prescriptions?: PmsPrescription[] | undefined;
  clinical?: PmsClinicalProfile | undefined;
  /**
   * Form feed keyed by schema field id. Reporter-block fields arrive tagged
   * per role class (prefill runs before the who-is-calling answer).
   */
  field_values?: { [key: string]: PmsFieldValues } | undefined;
  /** Mapped fields with no PMS value, keyed by schema field id. */
  gaps?: { [key: string]: number } | undefined;
  meta?: PmsCallMeta | undefined;
}

export interface GetPmsPatientPrefillResponse_FieldValuesEntry {
  key: string;
  value?: PmsFieldValues | undefined;
}

export interface GetPmsPatientPrefillResponse_GapsEntry {
  key: string;
  value: number;
}

export interface PmsPatient {
  mfi?: string | undefined;
  epost_member_id?: string | undefined;
  family_id?: string | undefined;
  first_name?: string | undefined;
  last_name?: string | undefined;
  /** ISO 8601 */
  dob?: string | undefined;
  gender?: string | undefined;
  email?: string | undefined;
  addresses?: PmsAddress[] | undefined;
  phones?: PmsPhone[] | undefined;
}

export interface PmsPhone {
  number?: string | undefined;
  type?: string | undefined;
  primary?: boolean | undefined;
}

export interface PmsAddress {
  line1?: string | undefined;
  line2?: string | undefined;
  city?: string | undefined;
  state?: string | undefined;
  zip?: string | undefined;
  /** HOME / TEMPORARY / ALTERNATE per PMS */
  type?: string | undefined;
  default_ship?: boolean | undefined;
}

export interface PmsPrescription {
  rx_number?: string | undefined;
  drug_name?: string | undefined;
  strength?: string | undefined;
  sig?: string | undefined;
  prescriber_name?: string | undefined;
  prescriber_phone?: string | undefined;
  prescriber_fax?: string | undefined;
  /** ISO 8601 — derived therapy start date */
  earliest_dispense?: string | undefined;
  /** ISO 8601 */
  latest_dispense_date?: string | undefined;
  days_supply?: number | undefined;
  written_date?: string | undefined;
  refills_remaining?: number | undefined;
  unfilled?: boolean | undefined;
  still_consuming?: boolean | undefined;
  /** joined from /reference/drugs */
  manufacturer?: string | undefined;
  /** catalog brand-match against the workflow's product catalog */
  in_program?: boolean | undefined;
  program_id?: string | undefined;
  order_id?: string | undefined;
}

export interface PmsClinicalProfile {
  /** sentinel-filtered */
  allergies?: string[] | undefined;
  /** sentinel-filtered */
  conditions?: string[] | undefined;
}

export interface PmsFieldValues {
  /** >=1; labels derived from data */
  values?: PmsValueOption[] | undefined;
  policy?: PmsFillPolicy | undefined;
  /**
   * Cascade group (rx / address / reporter) or empty. Reporter-block values
   * additionally carry the role class they apply to on each option.
   */
  cascade_group?: string | undefined;
  /** Per-field flags surfaced by the mapping engine, e.g. "strength_mismatch". */
  flags?: string[] | undefined;
}

export interface PmsValueOption {
  value?: string | undefined;
  /** e.g. "HOME · default ship"; empty for plain values */
  label?: string | undefined;
  /** provenance hint, e.g. "rx:RX100", "address:HOME" */
  source_ref?: string | undefined;
  /** reporter-block only: patient|hcp|caregiver|other */
  role_class?: string | undefined;
}

export interface PmsCallMeta {
  /**
   * Per-section upstream outcome: section name -> "ok" | "failed".
   * Failed sections degrade their fields to gaps.
   */
  sections?: { [key: string]: string } | undefined;
  adapter_calls?: number | undefined;
  duration_ms?: number | undefined;
  /**
   * Sections with sections[name] == "failed", derived server-side.
   * Additive field kept for UI back-compat with the pre-`sections` contract.
   */
  failed_sections?: string[] | undefined;
}

export interface PmsCallMeta_SectionsEntry {
  key: string;
  value: string;
}

/**
 * ============================================================================
 * PMS Service - Pharmacy Management System lookups for AE/PQC intake (HTTP API)
 * ============================================================================
 *
 * Read-side bridge to the customer's PMS (ePostRx via the Knipper REST
 * adapter), served in-process by the epostrx-go library
 * (github.com/100mslive/epostrx-go) — no PQCAgent hop. Powers patient lookup
 * and form prefill on the create-case page.
 *
 * Feature gating happens in Compass (service/pms.go: the pms_enabled workflow
 * feature flag, fail-closed) plus the library's mapping presence; the schema
 * module and workflow name are resolved server-side from the workflow record,
 * never from client input. See specs/AQ-655-pms-integration-end-to-end.md.
 *
 * PHI: search terms and results are PHI. Reads are GET with query params,
 * matching the existing search endpoints (accepted org-wide posture; see PRD).
 */
export interface PMSService {
  /**
   * SearchPmsPatients searches the PMS for patient candidates.
   * Last name (>=2 chars) is required unless patient_id is given.
   */
  searchPmsPatients(request: SearchPmsPatientsRequest): Promise<SearchPmsPatientsResponse>;
  /**
   * GetPmsPatientPrefill loads a confirmed patient's PMS record and returns
   * form-ready field values mapped to the workflow's schema field ids.
   */
  getPmsPatientPrefill(request: GetPmsPatientPrefillRequest): Promise<GetPmsPatientPrefillResponse>;
}
